<template>
  <div> <!-- v-if="$page.props.flash.success && show" -->
    <div v-if="$page.props.flash.success && show" :class="show ? 'show' : ''" class="alert alert-success alert-dismissible fade">
        <div>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20"><polygon points="0 11 2 9 7 14 18 3 20 5 7 18" /></svg>
          {{ $page.props.flash.success }}
        </div>
        <button @click="(show = false)" type="button" class="btn-close" aria-label="Close"></button>
    </div>
    <div v-if="($page.props.flash.error || Object.keys($page.props.errors).length > 0)" :class="show ? 'show' : ''" class="alert alert-danger alert-dismissible fade d-flex align-items-center">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" width="20" height="20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm1.41-1.41A8 8 0 1 0 15.66 4.34 8 8 0 0 0 4.34 15.66zm9.9-8.49L11.41 10l2.83 2.83-1.41 1.41L10 11.41l-2.83 2.83-1.41-1.41L8.59 10 5.76 7.17l1.41-1.41L10 8.59l2.83-2.83 1.41 1.41z" /></svg>
        <div v-if="$page.props.flash.error">{{ $page.props.flash.error }}</div>
        <div v-else class="">
          <span v-if="Object.keys($page.props.errors).length === 1">There is one form error.</span>
          <span v-else>There are {{ Object.keys($page.props.errors).length }} form errors.</span>
        </div>
        <button @click="(show = false)" type="button" class="btn-close" aria-label="Close"></button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
    }
  },
  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true
      },
      deep: true,
    },
  },
}
</script>
